"use client";
import { Suspense } from "react";
import { HomeNavbar } from "../common/HomeNavbar";
import { SignUpForm } from "./SignUpForm";
import { WelcomeSection } from "./WelcomeSection";

export default function SignUpClient() {
  return (
    <div className="flex min-h-screen flex-col bg-[#fcf5f1]">
      <HomeNavbar />
      <div className="flex grow items-center justify-center px-4 pt-28 pb-12 sm:px-8 lg:px-0">
        <div className="grid w-full max-w-7xl bg-white py-8 shadow-xl rounded-2xl sm:rounded-4xl md:grid-cols-2 lg:p-8">
          <WelcomeSection />
          {/* SignUpForm reads the ?converter= session id via useSearchParams,
              which opts the subtree into client-side rendering and so needs a
              Suspense boundary to keep the rest of the page prerenderable. */}
          <Suspense>
            <SignUpForm />
          </Suspense>
        </div>
      </div>
    </div>
  );
}
